// eslint-disable-next-line
export var TEMPLATE_TYPE = {
  ANSWER_CLOZE: 'ANSWER_CLOZE'
};